import { render } from "./StatsBoxes.vue?vue&type=template&id=aea0303a&ts=true"
import script from "./StatsBoxes.vue?vue&type=script&lang=ts"
export * from "./StatsBoxes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__